var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { formatTime } from './time-utils';
var CurrentTime = /** @class */ (function (_super) {
    __extends(CurrentTime, _super);
    function CurrentTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CurrentTime.prototype.componentDidMount = function () {
        var _this = this;
        this.intervalId = window.setInterval(function () {
            _this.forceUpdate();
        }, 1000);
    };
    CurrentTime.prototype.componentWillUnmount = function () {
        window.clearInterval(this.intervalId);
    };
    CurrentTime.prototype.render = function () {
        return formatTime(new Date());
    };
    return CurrentTime;
}(React.Component));
export default CurrentTime;



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/CurrentTime.tsx
// module id = 1841
// module chunks = 0